export default __webpack_public_path__ + "static/media/info_disclaimer.349ecaa0.svg";